import { Injectable } from '@angular/core';

interface ProcessIndicatorData {
  text: string;
  completionPercentage?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ProcessIndicatorService {
  public data: ProcessIndicatorData;

  public showProcessIndicator(data: ProcessIndicatorData): void {
    this.data = data;
  }

  public hideProcessIndicator(): void {
    this.data = null;
  }
}
